import React, { useState, useEffect, memo } from "react";

export default memo( function PreviewNFT(props) {
    const [sellItem, setSellItem] = useState({})
    const CloseDialog = () => {
        props.fucn()
    }
    useEffect(() => {
        setSellItem(props?.nftData)
    }, [props])

    console.log("model",sellItem)

    // update by ankit old src={sellItem?.nft_id?.image_id?.image?.water_mark_image_link ? sellItem?.nft_id?.image_id?.image?.water_mark_image_link : sellItem?.nft_id?.image_id?.image?.link}
    return (
        <div className="position-relative h-100">
            <div className="viewNftBody">
            <button onClick={CloseDialog}><i className="fa-regular fa-xmark"></i></button>
                <img src={
                sellItem?.listing_image_id?.water_mark_image_link ||
                sellItem?.nft_id?.image_id?.image?.water_mark_image_link ||
                sellItem?.listing_image_id?.link ||
                sellItem?.nft_id?.image_id?.image?.link
            } alt=""/> 
            </div>
        </div>
    )
})